import React, { useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'Bagaimana cara memulai konsultasi hukum?',
    a: 'Anda dapat menghubungi kami melalui WhatsApp, email, atau datang langsung ke kantor kami. Tim kami akan menjadwalkan sesi konsultasi sesuai ketersediaan Anda.',
  },
  {
    q: 'Berapa biaya konsultasi hukum?',
    a: 'Biaya konsultasi bervariasi tergantung jenis permasalahan dan kompleksitasnya. Kami menawarkan konsultasi awal yang terjangkau. Hubungi kami untuk informasi lebih lanjut.',
  },
  {
    q: 'Apakah informasi klien terjamin kerahasiaannya?',
    a: 'Ya, kerahasiaan klien adalah prioritas kami. Semua informasi yang Anda bagikan dijaga dengan ketat sesuai kode etik profesi advokat dan peraturan yang berlaku.',
  },
  {
    q: 'Jenis kasus apa saja yang dapat ditangani?',
    a: 'Kami menangani berbagai bidang hukum termasuk hukum perusahaan, sengketa tanah dan properti, perjanjian kontrak, litigasi, konsultasi hukum umum, dan hukum keluarga.',
  },
  {
    q: 'Apakah kantor hukum melayani klien di luar Pontianak?',
    a: 'Ya, kami melayani klien di seluruh Kalimantan Barat dan juga dapat memberikan konsultasi jarak jauh via online untuk klien dari luar daerah.',
  },
  {
    q: 'Berapa lama proses penanganan kasus?',
    a: 'Durasi penanganan kasus sangat bergantung pada kompleksitas dan jenis permasalahan hukum. Kami akan memberikan estimasi waktu yang realistis setelah analisis awal.',
  },
];

function FAQItem({ item, index }) {
  const [open, setOpen] = useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08, duration: 0.5 }}
      viewport={{ once: true }}
      className="glass-light rounded-xl border border-white/5 hover:border-gold-600/15 transition-all duration-300 overflow-hidden"
    >
      <button
        className="w-full flex items-center justify-between px-6 py-5 text-left"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="font-medium text-white text-sm md:text-base pr-4">{item.q}</span>
        <motion.div animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.3 }}>
          <ChevronDown size={20} className="text-gold-400 flex-shrink-0" />
        </motion.div>
      </button>

      <motion.div
        initial={false}
        animate={{ height: open ? 'auto' : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        className="overflow-hidden"
      >
        <p className="px-6 pb-5 text-navy-300 text-sm leading-relaxed">{item.a}</p>
      </motion.div>
    </motion.div>
  );
}

export default function FAQ() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <section id="faq" className="relative py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-600/30 to-transparent" />

      <div ref={ref} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-gold-400 text-sm font-semibold tracking-widest uppercase mb-3">
            FAQ
          </span>
          <h2 className="section-title mb-4">
            Pertanyaan yang{' '}
            <span className="gold-text">Sering Ditanyakan</span>
          </h2>
          <div className="divider-gold mx-auto" />
        </motion.div>

        <div className="space-y-3">
          {faqs.map((item, i) => (
            <FAQItem key={i} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
